"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.default = (function (_a) {
    var isLoading = _a.isLoading, loadingText = _a.loadingText;
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = window.inlineLoader) === null || _a === void 0 ? void 0 : _a.rainbowLoopPurplePath) {
            // TODO: make this 200x200
            window.initLottie('account-rainbow-loop-purple', window.inlineLoader.rainbowLoopPurplePath);
        }
    }, []);
    return (react_1.default.createElement("div", { className: 'text-center loading-message-inline padding-4', style: { display: isLoading ? 'block' : 'none', minHeight: '220px', maxWidth: '200px', margin: '0 auto', borderRadius: '4px' } },
        react_1.default.createElement("div", { id: 'account-rainbow-loop-purple' }),
        react_1.default.createElement("div", { className: 'font-lighter font-size-small margin-bottom-4' }, loadingText || 'Loading ...')));
});
